<ng-container>
    <!-- Title + toolbar: side by side on desktop, stacked (title on top,
         buttons below) on mobile so nothing gets cut off. -->
    <div class="storage-picker-header">
        <h4 class="popupTitle">{{title}}</h4>
        <div class="storage-toolbar">
            <button mat-icon-button>
                <mat-icon class="mat-icon-rtl-mirror">all_inbox</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" class="menu_button_storage" *ngIf="showAddButton">
                <mat-icon>playlist_add</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="onOpenStorage(null)">
                <mat-icon>playlist_add</mat-icon>
                <span>{{'storages.add'| translate}}</span>
            </button>
            </mat-menu>
            <span class="all_items_link" (click)="allItems()"
            [ngClass]="{'active': all_items_active}">{{'all_storages'| translate}}</span>
        </div>
    </div>

<div class="search">
    <mat-form-field class="example-full-width">
        <input matInput [(ngModel)]="searchQuery" (keyup)="filterChanged($event)" placeholder="Search">
    </mat-form-field>
</div>

    <div *ngIf="isLoading == true; else hasLoaded">
        <app-spinner diameter="20"></app-spinner>
    </div>
    <ng-template #hasLoaded>
        <div class="treeviewlist">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
            <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>
                <button mat-icon-button disabled></button>

                <mat-checkbox class="checklist-leaf-node"
                            [(ngModel)]="node.isSelected"
                            (ngModelChange)="onSelectionChange(node)"></mat-checkbox>
                <div *ngIf="!isFilter">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" class="menu_button_storages" *ngIf="showAddButton">
                    <mat-icon>playlist_add</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onOpenStorage(node)">
                        <mat-icon>playlist_add</mat-icon>
                        <span>{{'storages.add'| translate}}</span>
                    </button>
                    </mat-menu>
                </div>
                <div matTreeNodeToggle (click)="node.isSelected = !node.isSelected; onSelectionChange(node)" class="node_item storage_node_item" [ngClass]="{'active': node.active}">{{node.item}}</div>
            </mat-tree-node>
            <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>

                <button mat-icon-button matTreeNodeToggle
                        [attr.aria-label]="'toggle ' + node.filename">
                <mat-icon class="mat-icon-rtl-mirror">
                    {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
                </button>
                <mat-checkbox class="checklist-leaf-node"
                [(ngModel)]="node.isSelected"
                (ngModelChange)="onSelectionChange(node)"></mat-checkbox>

                <div *ngIf="!isFilter">
                    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu" class="menu_button_storages">
                    <mat-icon>playlist_add</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onOpenStorage(node)">
                        <mat-icon>playlist_add</mat-icon>
                        <span>{{'storages.add'| translate}}</span>
                    </button>
                    </mat-menu>
                </div>
                <div matTreeNodeToggle (click)="node.isSelected = !node.isSelected; onSelectionChange(node)" class="node_item storage_node_item" [ngClass]="{'active': node.active}">{{node.item}}</div>
            </mat-tree-node>
            </mat-tree>
        </div>
    </ng-template>
<mat-dialog-actions fxLayoutAlign="center center">
    <button mat-button mat-raised-button mat-dialog-close (click)="cancel()">{{ "cancel" | translate }}</button>
    <!-- <button mat-button mat-raised-button color="accent" data-test="CheckboxListWrapper__storages" (click)="onOpenStorage()">{{ "storages.add" | translate }}</button> -->
    <button mat-button mat-raised-button color="primary" (click)="saveProductStorage()" data-test="CheckboxListWrapper__add">
        {{ isFilter ? ("find" | translate) : ("save" | translate) }}
    </button>
</mat-dialog-actions>
</ng-container>

